import appGlobalScript from '/builds/zappar/zapcode-creator/zappar-com/web-components/packages/core/src/global.ts';
export const globalScripts = appGlobalScript;
